'use strict';
Ilduomo
.controller('todoController', function ($scope) {
   
   
    
});